<template>
  <div class="paymentdetails">
    <div class="header header-payment">
      <div class="head_name">Payment</div>
      <img src="../assets/images/arrow-w.svg" @click="goBack()" />
     </div>
    <div class="container container-payment">
      <section class="payment-details-order">
        <div class="payment-dlt-frm">
          <div class="cost-dtl-box">
            <div class="coin-charge">
              <img :src="_goldTransactionInfo.media_images" />
              <div class="coin-chrge-txt"> {{_goldTransactionInfo.description}}</div>
            </div>
            <div class="gold_cost">
              <span class="fixed-cst">{{$t('constructionfee')}}:</span>
              <span class="fixed-bln">₹{{_goldTransactionInfo.price}}</span>
            </div>
            <div class="gold-cst-disc">
              <span class="wallet-cst">
                 <input type="checkbox" checked v-model="isChecked" />
                   Wallet {{$t('discount')}}
                 </span>
              <span class="wallet-cst-bln">{{roundOff(walletDiscount, 2)}}</span>
            </div>
            <div class="gold_cost gold-cost-pay">
              <span class="fixed-cst">{{$t('pay')}}</span>
              <span class="fixed-bln bln-green">=₹{{roundOff(_goldTransactionInfo.price-(isChecked ? walletDiscount : 0),2)}}</span>
            </div>
            <div class="gold_cost gold-cost-pay">
              <span class="fixed-cst">{{$t('delivery_date')}}</span>
              <span class="fixed-bln ">{{_goldTransactionInfo.estimated_dispatch}}</span>
            </div>
          </div>
        </div>
        <div class="payment-dlt-frm border-form"></div>
        <div class="btn-block">
          <Button
            class="order-btn-block"
            @saveUserPaymentDetail="sumbitPaymentDetail"
            :btn_txt="`Pay ₹${roundOff(_goldTransactionInfo.price-(isChecked ? walletDiscount : 0),2)}`"
          ></Button>
        </div>
      </section>
    </div>
    <div class="loader" v-if="loading">
      <img src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SessionHelper, X_AUTH_TOKEN, X_AUTH_ID} from "../utils/session" 
import Button from "../components/Button";
import { getDiscount, roundOff } from "../utils/helper";
import { BASE_API_URL } from '../utils/constant'
export default {
  name: "PurchasePaymentForm",
  components: {
    Button
  },

  data() {
    return {
      walletDiscount: 0,
      isChecked: false,
      loading: false,
      _goldTransactionInfo: null
    };
  },

   computed: {
    ...mapGetters(["user"])
  },

  methods: {
    roundOff,
    calculateWalletDiscount() {
      const { purchase_offer, user_purse_details } = this.user;
      if (!Number(user_purse_details.wallet)) {
        this.walletDiscount = 0;
        return;
      }
      const walletOfferAmount =
        (this._goldTransactionInfo.price * purchase_offer.wallet_percentage) / 100;
      if (walletOfferAmount > user_purse_details.wallet) {
        this.walletDiscount = user_purse_details.wallet;
        return;
      }
      if (walletOfferAmount > purchase_offer.max_wallet) {
        this.walletDiscount = purchase_offer.max_wallet;
        return;
      }
      this.walletDiscount = walletOfferAmount;
      const total_amount = this._goldTransactionInfo.price - this.walletDiscount;
      if (total_amount < 1) {
        this.walletDiscount = 0;
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    sumbitPaymentDetail() {
     this.loading = !this.loading; 
     window.location.href = `${BASE_API_URL}delivery_management/delivery_confirmation?transaction_id=${String(
        this._goldTransactionInfo.tx_id
      )}&wallet_amount=${this.walletDiscount}&${X_AUTH_ID}=${SessionHelper.getCookie(X_AUTH_ID)}&${X_AUTH_TOKEN}=${SessionHelper.getCookie(X_AUTH_TOKEN)}`;
    }
  },

  created() {
    this._goldTransactionInfo = SessionHelper.getCookie('_goldTransactionInfo') ? JSON.parse(SessionHelper.getCookie('_goldTransactionInfo')) : null
    this.calculateWalletDiscount()
  },

};
</script>